import { TezaurusCreateApi } from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import TezaurusCreate from '../../model/TezaurusCreate';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new TezaurusCreateApi(apiConfiguration(tezauryPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const createTezaurus = async (
  tezaurusCreate: TezaurusCreate,
  options: { headers?: AxiosRequestHeaders } = {},
): Promise<ClientResponse<void>> => {
  const { status } = await client.createTezaurus(tezaurusCreate, options);
  return { responseCode: status };
};
